import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import {
  TiimeFormModule,
  TiimeIconModule,
  TiimeInputContainerModule,
  TiimeSelectModule,
  TiimeOptionModule
} from 'tiime-material';

import { SelectBase } from '@bases/selector/select.base';
import { Signatory } from '@models/signatory';

@Component({
  selector: 'app-signatory-select',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TiimeInputContainerModule,
    TiimeFormModule,
    TiimeSelectModule,
    TiimeOptionModule,
    TiimeIconModule
  ],
  templateUrl: './signatory-select.component.html',
  styleUrls: ['./signatory-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignatorySelectComponent extends SelectBase<Signatory> {
  @Input() label = 'Signataire';
  @Input() allowCreateOption = false;
  @Input() createOptionLabel = 'Ajouter un signataire';

  @Output() readonly create: EventEmitter<void> = new EventEmitter<void>();

  emitCreate(event: Event): void {
    event.preventDefault();
    this.create.emit();
  }
}
